import "./ScalabilityChoose.css";
import img from "../scalabiltyassets/choose.png";

export default function ScalabilityChoose() {
  return (
    <div id="scalability-choose" className="outsourcemainclass">
           <div className="right">
        <img src={img} alt="error" />
      </div>
      <div className="left">
        <div className="offer-item content content1">
          <h2>Key Benefits of DevOps Automated Testing</h2>
          <p>
           Empowering scalable systems that deliver high performance, operational resilience, and optimized costs while supporting continuous growth and evolving business demands.
          </p>
          <ul>
            <li>
              Assessment &amp; Planning
              <p>Analyze your development workflow, tools, and objectives</p>
            </li>
            <li>
              Assessment &amp; Planning
              <p>Analyze your development workflow, tools, and objectives</p>
            </li>
            <li>
              Assessment &amp; Planning
              <p>Analyze your development workflow, tools, and objectives</p>
            </li>
            <li>
              Assessment &amp; Planning
              <p>Analyze your development workflow, tools, and objectives</p>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}
